const URL = {
  ACTIVATION: 'Statistics/ActivationStats',
  SUPER_ACTIVATION: 'Statistics/SuperActivationStats',
}

export default URL
